import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post('https://cna.clublostortugas.com/api/api.php?action=login', {
                username,
                password
            });

            if (res.data.success) {
                localStorage.setItem('adminToken', res.data.token);
                localStorage.setItem('adminUser', res.data.user);
                navigate('/dashboard');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Error de conexión');
        }
    };

    return (
        <div className="container mt-5" style={{ maxWidth: '400px' }}>
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                <div className="admin-header text-center py-4">
                    <img
                        src="/img/logo-tortugas.png"
                        alt="Club Los Tortugas"
                        style={{ maxWidth: '140px' }}
                    />
                </div>
                <div className="card-body p-4">
                    <h4 className="card-title text-center fw-bold mb-4">Panel Administrativo</h4>
                    {error && <div className="alert alert-danger border-0 small">{error}</div>}
                    <form onSubmit={handleLogin}>
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">USUARIO</label>
                            <input
                                type="text"
                                className="form-control form-control-lg bg-light border-0"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">CONTRASEÑA</label>
                            <input
                                type="password"
                                className="form-control form-control-lg bg-light border-0"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-club btn-lg w-100 rounded-pill mt-3 fw-bold shadow-sm">
                            INGRESAR
                        </button>
                    </form>
                </div>
            </div>
            <p className="text-center mt-4 small text-muted">CNA 2026 - Control de Inscripciones</p>
        </div>
    );
};

export default Login;
